import axiosStudentInstance from "../../axiosStudentInstance.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { resetStudentProfile } from "../student/slice.js";
// import { setTeacherToken } from "../authTeacher/slice.js";
// import { setStudentToken } from "./slice.js";
// import axios from "axios";

export const registerStudent = createAsyncThunk(
  "authStudent/register",
  async ({ email, password, lang }, { rejectWithValue }) => {
    try {
      const { data } = await axiosStudentInstance.post("/student/register", {
        email,
        password,
        lang,
      });
      // console.log(data);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Registration failed"
      );
    }
  }
);

export const loginStudent = createAsyncThunk(
  "authStudent/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const { data } = await axiosStudentInstance.post("/student/login", {
        email,
        password,
      });
      localStorage.setItem("userRole", data.role);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  }
);

// export const logoutStudent = createAsyncThunk(
//   "authStudent/logout",
//   async (_, { rejectWithValue }) => {
//     try {
//       await axiosStudentInstance.post("/student/logout"); // ничего не передаём
//       localStorage.removeItem("userRole");
//       return null;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || "Logout failed");
//     }
//   }
// );
export const logoutStudent = createAsyncThunk(
  "authStudent/logout",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(resetStudentProfile()); // 🧹 очистка стейта ДО запроса

      await axiosStudentInstance.post("/student/logout");
      localStorage.removeItem("userRole");

      return null;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Logout failed");
    }
  }
);
export const getStudentProfile = createAsyncThunk(
  "authStudent/getStudentProfile",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosStudentInstance.get("/student/profile");

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch profile"
      );
    }
  }
);

export const loginStudentWithGoogle = createAsyncThunk(
  "authStudent/loginStudentWithGoogle",
  async (code, thunkAPI) => {
    try {
      const { data } = await axiosStudentInstance.post(
        "/student/google-login",
        {
          code,
        }
      );
      localStorage.setItem("userRole", data.role);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response.data.message || "Google login failed"
      );
    }
  }
);

export const verifyStudentEmailOperation = createAsyncThunk(
  "authStudent/verifyEmail",
  async (token, { rejectWithValue }) => {
    try {
      const { data } = await axiosStudentInstance.get(
        `/auth/verify-student-email?token=${token}`,
        { withCredentials: true }
      );
      // console.log(data);
      localStorage.setItem("userRole", data.role);
      return data.studentToken;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Ошибка подтверждения email"
      );
    }
  }
);
export const refreshTokenStudent = createAsyncThunk(
  "authStudent/refresh",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosStudentInstance.post(
        "/student/refresh",
        null,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      // console.log(error);

      // 🔒 Ожидаемая ошибка — устаревший или отсутствующий токен
      if (error?.response?.status === 401) {
        return rejectWithValue(null);
      }

      // ❗ Неожиданная ошибка — логируем и возвращаем текст
      return rejectWithValue(
        error?.response?.data?.message || "Token refresh failed"
      );
    }
  }
);
